import React from 'react';
import CharacterFlipCard from './CharacterFlipCard';
import './flipcard.css';

// Floating chat
import FloatingChat from '@/components/FloatingChat';
const ENABLE_CHAR_CHAT = false;

// Background + character images (keep your originals)
import EscapeFromDeva from '../assets/images/escape from deva.png';
import AerwynaImg from '../assets/images/Aerwyna.png';
import VarroImg from '../assets/images/Varro.png';
import LuciusImg from '../assets/images/Lucius.png';
import CatenaImg from '../assets/images/Catena.png';
import NestorImg from '../assets/images/Nestor.png';
import CunobaraImg from '../assets/images/Cunobara.png';
import JuliusImg from '../assets/images/Julius.png';

const Characters = () => {
  const characters = [
    {
      name: 'Aerwyna: The Flame in the Heather',
      image: AerwynaImg,
      backstory:
        "A daughter of the Ordovices hills, Aerwyna is the embodiment of indigenous sovereignty. Born to lead, she carries the fire of her ancestors and the weight of her people's future. Her bow never misses, her resolve never wavers, and her love for the land runs deeper than Roman roads.",
      symbols:
        'Bow (precision), Heather & Stone (endurance), Wind (whispered strength)',
      spotify: 'https://open.spotify.com/episode/6nOSQ9K7Qyrnr00ahXLZKP',
    },
    {
      name: 'Varro: The Broken Eagle',
      image: VarroImg,
      backstory:
        'Once a centurion of Legio XX, Varro is a man caught between duty and vengeance. Haunted by the massacre at Lugdunum and the loss of his men, he walks the Ridgeway seeking redemption. His eagle standard is both burden and beacon, leading him toward an uncertain destiny.',
      symbols:
        'Eagle (burden and beacon), Chains (suffering and unity), Ridgeway (path to redemption)',
      spotify: 'https://open.spotify.com/episode/2GHnmTTmYtEpi9cdaMNPsY',
    },
    {
      name: 'Lucius: The Hound of Two Worlds',
      image: LuciusImg,
      backstory:
        'Lucius Cunovalos bridges the worlds of Rome and the tribes. Born of both bloodlines, he serves as translator, negotiator, and guardian. His loyalty runs deep, but his heart is torn between the empire that raised him and the people who birthed him.',
      symbols:
        'Hound (guardianship), Eagle (ideal of unity), Road West (path to freedom)',
      spotify: 'https://open.spotify.com/episode/0Phu9phzE46rETAxzDvl5f',
    },
    {
      name: 'Paulus Catena: The Merchant of Chains',
      image: CatenaImg,
      backstory:
        'Ruthless and cunning, Catena rises by trading in fear and suffering. From the slave markets to the gladiatorial arenas, he builds his empire on the broken dreams of others. Yet even he cannot escape the chains of his own making.',
      symbols:
        'Chains (doom and control), Arena (empire of spectacle), Dice (false control)',
      spotify: 'https://open.spotify.com/episode/28MPEYN2FsHtQ0gAD28yIX',
    },
    {
      name: 'Nestor: The Healer at War',
      image: NestorImg,
      backstory:
        'A Greek physician torn by his oath, Nestor serves empire reluctantly. His hands heal Roman soldiers while his heart bleeds for their victims. In the fortress infirmary, he wages his own quiet war against the machinery of conquest.',
      symbols:
        'Herbs & Salves (weapons of healing), Infirmary (cage and battleground), Silence (hidden struggle)',
      spotify: 'https://open.spotify.com/episode/5zbq68Kzuhw43JiG41vQfc',
    },
    {
      name: 'Cunobara: The Voice of the Bones',
      image: CunobaraImg,
      backstory:
        'Seer and guide of the Ordovices, Cunobara is the living link between past and present. Her visions pierce the veil of time, revealing the threads that bind all fates. In the stone circles, she speaks with the voices of the ancestors.',
      symbols:
        "Bone Pendant (lineage), Stone Circle (power place), Raven's Cry (harbinger)",
      spotify: 'https://open.spotify.com/episode/6JpCmxNWcRQv7sJehnFd94',
    },
    {
      name: 'Julius: The Iron Sentinel',
      image: JuliusImg,
      backstory:
        "Julius, a centurion of unshaken resolve, holds the line not for Rome's glory but for the men who stand beside him. At the South Gate, he makes his final stand, knowing that some oaths are worth more than life itself.",
      symbols:
        'Shield (endurance), South Gate (decisive stand), Oath (unbroken loyalty)',
      spotify: 'https://open.spotify.com/episode/62wHvmSgROXmI4XQjipYbR',
    },
  ];

  // Adjust this value (0 = fully transparent, 1 = fully opaque)
  const backgroundOpacity = 0.5;

 // ...everything above unchanged...

  return (
    <>
      <div
        className="min-h-screen py-10"
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        {/* Background image with adjustable opacity and fixed position */}
        <div
          style={{
            backgroundImage: `url(${EscapeFromDeva})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            opacity: backgroundOpacity,
            zIndex: 0,
          }}
        />
        {/* Foreground content */}
        <div className="relative max-w-6xl mx-auto px-6 z-10">
          <h1 className="text-4xl font-bold text-center mb-12 text-white">
            Characters of Blood and Honour
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center">
            {characters.map((char, idx) => (
              <CharacterFlipCard key={idx} character={char} />
            ))}
          </div>
        </div>
      </div>

      {/* Floating chat as a sibling (not clipped by overflow).
          Explicit storageKey makes the global guard definitive. */}
      {ENABLE_CHAR_CHAT && (
  <FloatingChat
    apiPath="/api/characters"
    title="Characters Chat"
    storageKey="characters"
    docsOnly
  />
)}
    </>
  );
};

export default Characters;

